/**
 * @file LoggerService.ts
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { injectable } from "inversify";
import { Logger } from "./Logger";

/**
 * A class definition for LoggerService
 */
@injectable()
export class LoggerService implements Logger {

    private enabledLog = false;

    /**
     * Logs warning messages
     * @param message string
     * @param root string
     * @returns 
     */
    warning(message: string, root: string) : void {
        if(!this.enabledLog){
            return;
        }
        console.warn(this.getFormattedLog(message, root));
    }
    
    /**
     * Logs verbose messages
     * @param message string
     * @param root string
     * @returns 
     */
    verbose(message: string, root: string): void {
        if(!this.enabledLog){
            return;
        }
        console.log(this.getFormattedLog(message, root));
    }

    /**
     * Logs error messages
     * @param message string
     * @param root string
     * @returns 
     */
    error(message: string, root: string) : void {
        if(!this.enabledLog){
            return;
        }
        console.error(this.getFormattedLog(message, root));
    }

    /**
     * Gets formatted logs
     * @param message string
     * @param root string
     * @returns 
     */
    private getFormattedLog = (message: string, root: string) => `[${root}] : ${message}`;

}